import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserCircle } from "@fortawesome/free-solid-svg-icons";
const NavBar = () => {
  return (
    <nav className="nav-bar">
      <div className="nav-homeTitle">
        <Link to="/Home">
          <h1>Relation Apps</h1>
        </Link>
      </div>
      <div className="links">
        <Link to="/Katalog">Katalog</Link>
        <a href="http://www.teachforindonesia.org/about-us/">Tentang Kami</a>
        <Link to="/Kelas">Kelas</Link>
        <a href="http://www.teachforindonesia.org/contact-us/">Contact</a>
        <Link to="/ProfilePage">
          <FontAwesomeIcon icon={faUserCircle}></FontAwesomeIcon>
        </Link>
      </div>
    </nav>
  );
};

export default NavBar;
